import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { heroHeadingSchema } from './schema';

const HeroHeadingData = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = heroHeadingSchema({ ...props, intl });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default HeroHeadingData;
